import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import aboutUsLogo from '../../assets/img/AboutUsLogo.webp'
import avrasyaPortal from '../../assets/img/avrasyaPortal.webp'
import burgerMenu from '../../assets/img/burger-menu.svg'
import closeBtn from '../../assets/img/close-btn.svg'
import Construction from '../../assets/img/Construction.webp'
import CoreServices from '../../assets/img/CoreServices.webp'
import CorporateSupport from '../../assets/img/CorporateSupport.webp'
import employers from '../../assets/img/employers.webp'
import Hospitality from '../../assets/img/Hospitality.webp'
import logo from '../../assets/img/logo.png'
import Manufacturing from '../../assets/img/Manufacturing.webp'
import OurValues from '../../assets/img/OurValues.webp'
import { LanguageSwitcher } from '../LanguageSwitcher/LanguageSwitcher.jsx'
import './Header.css'

export const Header = () => {
	const { t } = useTranslation()
	const location = useLocation()


	const navLinksRef = useRef(null) 
	const menuBtnRef = useRef(null) 
	const closeBtnRef = useRef(null) 
	const wrapperRef = useRef(null) 


	const isOpen = () => !!menuBtnRef.current?.checked

	const closeMenu = () => {
		if (closeBtnRef.current) closeBtnRef.current.checked = true
	}


	useEffect(() => {
		const ul = navLinksRef.current
		if (!ul) return
		const onClick = e => {
			if (!isOpen()) return
			const a = e.target.closest('a')
			if (a) closeMenu()
		}
		ul.addEventListener('click', onClick)
		return () => ul.removeEventListener('click', onClick)
	}, [])

	
	useEffect(() => {
		const onDown = e => {
			
			if (window.matchMedia('(max-width: 970px)').matches !== true) return
			if (!isOpen()) return

			const target = e.target
			const menu = navLinksRef.current
			const wrap = wrapperRef.current
			if (!menu || !wrap) return

			
			if (menu.contains(target)) return

			
			const openLabel = wrap.querySelector('label.btn.menu-btn')
			if (openLabel && openLabel.contains(target)) return

			
			closeMenu()
		}

		document.addEventListener('mousedown', onDown)
		document.addEventListener('touchstart', onDown, { passive: true })
		return () => {
			document.removeEventListener('mousedown', onDown)
			document.removeEventListener('touchstart', onDown)
		}
	}, [])

	
	useEffect(() => {
		const onKey = e => {
			if (e.key === 'Escape' && isOpen()) closeMenu()
		}
		document.addEventListener('keydown', onKey)
		return () => document.removeEventListener('keydown', onKey)
	}, [])

	
	useEffect(() => {
		if (isOpen()) closeMenu()
		
	}, [location.pathname])

	return (
		<header className='header'>
			<nav>
				<div className='wrapper' ref={wrapperRef}>
					<Link to='/' className='logo'>
						<img src={logo} alt='logo' />
						<p>
							Avrasya <br />
							<span>Consulting</span>
						</p>
					</Link>

					
					<input type='radio' name='slider' id='menu-btn' ref={menuBtnRef} />
					<input type='radio' name='slider' id='close-btn' ref={closeBtnRef} />

					<ul className='nav-links' ref={navLinksRef}>
						<label htmlFor='close-btn' className='btn close-btn'>
							<i className='fas fa-times'>
								<img src={closeBtn} alt='close' />
							</i>
						</label>

						<li>
							<Link className='desktop-item' to='/aboutUs'>
								{t('about-us')}
							</Link>
							<input type='checkbox' id='aboutUs' />
							<label htmlFor='aboutUs' className='mobile-item'>
								{t('about-us')}
							</label>
							<div className='mega-box'>
								<div className='content'>
									<div className='row'>
										<img src={aboutUsLogo} alt='' />
									</div>
									<div className='row'>
										<header>{t('about-avrasya')}</header>
										<ul className='mega-links'>
											<li>
												<Link to='/Purpose'>{t('purpose')}</Link>
											</li>
											<li>
												<Link to='/History'>{t('history')}</Link>
											</li>
											<li>
												<Link to='/Vision'>{t('vision')}</Link>
											</li>
											<li>
												<Link to='/Mission'>{t('mission')}</Link>
											</li>
										</ul>
									</div>
									<div className='row'>
										<img src={OurValues} alt='OurValues' />
									</div>
									<div className='row'>
										<header>{t('our-values')}</header>
										<ul className='mega-links'>
											<li>
												<Link to='/Ethics-Compliance'>
													{t('ethics-compliance')}
												</Link>
											</li>
											<li>
												<Link to='/Relationship-based'>
													{t('relationship-based')}
												</Link>
											</li>
											<li>
												<Link to='/CodeOfConduct'>{t('code-of-conduct')}</Link>
											</li>
											<li>
												<Link to='/CorporateResponsibility'>
													{t('corporate-responsibility')}
												</Link>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</li>

						<li>
							<Link className='desktop-item' to='/Services'>
								{t('services')}
							</Link>
							<input type='checkbox' id='services' />
							<label htmlFor='services' className='mobile-item'>
								{t('services')}
							</label>
							<div className='mega-box'>
								<div className='content'>
									<div className='row'>
										<img src={CoreServices} alt='CoreServices' />
									</div>
									<div className='row'>
										<header>{t('core-service')}</header>
										<ul className='mega-links'>
											<li>
												<Link to='/Recruitment'>{t('recruitment')}</Link>
											</li>
											<li>
												<Link to='/StaffingManagement'>
													{t('staffing-management')}
												</Link>
											</li>
											<li>
												<Link to='/360Hiring'>{t('360hiring')}</Link>
											</li>
										</ul>
									</div>
									<div className='row'>
										<ul className='mega-links'>
											<img src={CorporateSupport} alt='CorporateSupport' />
										</ul>
									</div>
									<div className='row'>
										<header>{t('corporate-support')}</header>
										<ul className='mega-links'>
											<li>
												<Link to='/CostReduction'>{t('cost-reduction')}</Link>
											</li>
											<li>
												<Link to='/StaffAccommodation'>
													{t('staff-accommodation')}
												</Link>
											</li>
											<li>
												<Link to='/HrConsultancy'>{t('hr-consultancy')}</Link>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</li>

						<li>
							<Link className='desktop-item' to='/OurReferences'>
								{t('references')}
							</Link>
							<input type='checkbox' id='references' />
							<label htmlFor='references' className='mobile-item'>
								{t('references')}
							</label>
							<div className='mega-box'>
								<div className='content'>
									<div className='row'>
										<header className='references-header'>
											{t('hospitality')}
										</header>
										<ul className='mega-links'>
											<Link to='/Hospitality'>
												<img src={Hospitality} alt='Hospitality' />
											</Link>
										</ul>
									</div>
									<div className='row'>
										<header className='references-header'>
											{t('manufacturing')}
										</header>
										<ul className='mega-links'>
											<Link to='/Manufacturing'>
												<img src={Manufacturing} alt='Manufacturing' />
											</Link>
										</ul>
									</div>
									<div className='row'>
										<header className='references-header'>
											{t('construction')}
										</header>
										<ul className='mega-links'>
											<Link to='/Construction'>
												<img src={Construction} alt='Construction' />
											</Link>
										</ul>
									</div>
								</div>
							</div>
						</li>

						<li>
							<Link className='desktop-item' to='#'>
								{t('corporate')}
							</Link>
							<input type='checkbox' id='corporate' />
							<label htmlFor='corporate' className='mobile-item'>
								{t('corporate')}
							</label>
							<div className='mega-box'>
								<div className='content'>
									<div className='row'>
										<img src={employers} alt='' />
									</div>
									<div className='row'>
										<header>{t('employers')}</header>
										<ul className='mega-links'>
											<li>
												<Link to='/Solutions'>{t('solutions')}</Link>
											</li>
											<li>
												<Link to='/DemandForm'>{t('demand-form')}</Link>
											</li>
										</ul>
									</div>
									<div className='row'>
										<header>{t('agent')}</header>
										<ul className='mega-links'>
											<li>
												<Link to='/Network'>{t('network')}</Link>
											</li>
											<li>
												<Link to='/AgentForm'>{t('agent-form')}</Link>
											</li>
										</ul>
									</div>
									<div className='row'>
										<ul className='mega-links'>
											<li className='avrasya-portal'>
												<Link to='/Portal'>
													<img src={avrasyaPortal} alt='Portal' />
												</Link>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</li>

						<li>
							<Link className='desktop-item' to='#'>
								{t('contacts')}
							</Link>
							<input type='checkbox' id='contacts' />
							<label htmlFor='contacts' className='mobile-item'>
								{t('contacts')}
							</label>
							<ul className='drop-menu'>
								<li>
									<Link to='/Individuals'>{t('individuals')}</Link>
								</li>
								<li>
									<Link to='/Locations'>{t('locations')}</Link>
								</li>
							</ul>
						</li>

						<li>
							<LanguageSwitcher />
						</li>
					</ul>

					<label htmlFor='menu-btn' className='btn menu-btn'>
						<img src={burgerMenu} alt='menu' />
						<i className='fas fa-bars' />
					</label>
				</div>
			</nav>
		</header>
	)
}
